import React from 'react';
import PropTypes from 'prop-types';

import InstagramSliderNotVerified
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderNotVerified';
import InstagramSliderVerified
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderVerified';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';

import './InstagramSliderItemExpandedContent.css';

function InstagramSliderItemExpandedContent(props) {
  const { item, deleteImageSlider } = props;

  const renderVerificationContent = item.instagram_is_verified ?
    <InstagramSliderVerified item={item} /> : <InstagramSliderNotVerified item={item} />;

  return (
    <div className="instagram-slider-expanded-content__component">
      {renderVerificationContent}

      <div className="delete">
        <CommonLinkDeleteButton
          linkItem={item}
          deleteFunction={deleteImageSlider}
        />
      </div>
    </div>
  );
}

InstagramSliderItemExpandedContent.propTypes = {
  deleteImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default InstagramSliderItemExpandedContent;
